// extracted by mini-css-extract-plugin
export default {"loginPage":"PainelLogin_loginPage__6WSTp","loginPanel":"PainelLogin_loginPanel__NhVRg","errorMessage":"PainelLogin_errorMessage__MSIFx"};